export enum SessionStorageKeys {
  INITIAL_PATH_NAME_BEFORE_AUTH = 'initialPathNameBeforeAuth'
}
